import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Fade from 'react-reveal/Fade';

const faqs = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => ({
  q: `accounts.faq.${n}.q`,
  a: `accounts.faq.${n}.a`,
}));

function FAQ() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(null);

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      <div className="mx-auto max-w-[1220px] px-[20px] xl:px-0">
        {/* Title */}
        <Fade bottom>
        <div className="flex flex-col items-center gap-[15px]">
          <h2 className="font-['Nunito_Sans'] text-[26px] xl:text-[32px] font-black leading-[1.5] text-[#3273b4]">
            {t("accounts.faq.title")}
          </h2>
          <span className="block h-[4px] w-[104px] bg-[#05193a]" />
        </div>
        </Fade>

        {/* Accordion */}
        <Fade bottom delay={200}>
        <div className="mt-[45px] flex flex-col">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="border-b border-[rgba(19,50,97,0.5)]"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-[20px] px-[25px] py-[15px] text-left"
                >
                  <p className="font-['Nunito_Sans'] text-[16px] font-black leading-[1.4] text-[#05193a]">
                    {t(faq.q)}
                  </p>
                  <span className="flex shrink-0 h-[34px] w-[36px] items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`transition-transform duration-200 ${isOpen ? "rotate-45" : ""}`}
                    >
                      <path
                        d="M10 4V16M4 10H16"
                        stroke="#05193a"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-[25px] pb-[15px]">
                    <p className="font-['Nunito_Sans'] text-[14px] xl:text-[16px] font-light leading-[1.5] text-[#05193a]">
                      {t(faq.a)}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default FAQ;
